/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Imagevalue1Inputs */

const en_entity_imagevalue1 = /** @type {(inputs: Entity_Imagevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Value`)
};

const de_entity_imagevalue1 = /** @type {(inputs: Entity_Imagevalue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildwert`)
};

/**
* | output |
* | --- |
* | "Image Value" |
*
* @param {Entity_Imagevalue1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_imagevalue1 = /** @type {((inputs?: Entity_Imagevalue1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Imagevalue1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_imagevalue1(inputs)
	return de_entity_imagevalue1(inputs)
});
export { entity_imagevalue1 as "entity_imageValue" }